/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ConfigurationForGcpConsolidatedChargesReport extends models.ConfigurationForFinOpsConsolidatedReport {
    constructor() {
        super();
        this.setDiscriminator("ConfigurationForGcpConsolidatedChargesReport");
    }

    getFixupPrototypeFunction() { return ConfigurationForGcpConsolidatedChargesReport.fixupPrototype; }

    static newInstance(model: Partial<ConfigurationForGcpConsolidatedChargesReport>): ConfigurationForGcpConsolidatedChargesReport {
        let obj = Object.assign(new ConfigurationForGcpConsolidatedChargesReport(), model);
        ConfigurationForGcpConsolidatedChargesReport.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ConfigurationForGcpConsolidatedChargesReport>): ConfigurationForGcpConsolidatedChargesReport {
        if (!model) return null;
        return ConfigurationForGcpConsolidatedChargesReport.newInstance(<ConfigurationForGcpConsolidatedChargesReport> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ConfigurationForGcpConsolidatedChargesReport) {
        if (!obj) return;

        models.ConfigurationForGcpConsolidatedChargesReport.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ConfigurationForGcpConsolidatedChargesReport): boolean {
        if (models.ConfigurationForFinOpsConsolidatedReport.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ConfigurationForGcpConsolidatedChargesReport.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
